import { VueRenderer } from '@tiptap/vue-2'
import tippy from 'tippy.js'
import AtPopup from './at-popup.vue'
import {APIRequest} from "@/node-sdk";

export default {
    items: async ({ query }) => {
           let users = await APIRequest.get_with_request(process.env.VUE_APP_API, 'users', `?search=${query}`) ;
           return users[0] ;
    },

    render: () => {
        let component
        let popup

        return {
            onStart: props => {
                component = new VueRenderer(AtPopup, {
                    parent: this,
                    propsData: props,
                    // using vue 3:
                })

                popup = tippy('body', {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    placement: 'bottom-start',
                })
            },

            onUpdate(props) {
                component.updateProps(props)

                popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                })
            },

            onKeyDown(props) {
                if (props.event.key === 'Escape') {
                    popup[0].hide()

                    return true
                }

                return component.ref?.onKeyDown(props)
            },

            onExit() {
                popup[0].destroy()
                component.destroy()
            },
        }
    },
}